module.exports = __webpack_public_path__ + "img/index-banner2.7b949168.png";